/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/ProcessCostSupport/summaryStyle";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type CostsSummaryProps = {
  formData: Record<string, any>;
};

const CostsSummary = ({ formData }: CostsSummaryProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Ausgaben</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        Abzüge
      </Grid>
      <Box id={"hasTaxDecuction"} />
      <Grid size={12}>
        Steuern: {formData.hasTaxDecuction === "yes" ? formData.taxAmount + " €" : "keine Abzüge"}
      </Grid>
      <Box id={"hasSocialSecurityDeduction"} />
      <Grid sx={summaryStyle.addMargin} size={12}>
        Sozialversicherung: {formData.hasSocialSecurityDeduction === "yes" ? formData.socialSecurityAmount + " €" : "keine Abzüge"}
      </Grid>
      <Box id={"hasOtherInsuranceDeduction"} />
      <Grid sx={summaryStyle.addMargin} size={12}>
        Sonstige Versicherungen: {formData.hasOtherInsuranceDeduction === "yes" ? formData.otherInsuranceAmount + " €" : "keine Abzüge"}
      </Grid>
      <Box id={"hasMobilityCostDeduction"} />
      <Grid sx={summaryStyle.addMargin} size={12}>
        Fahrt zur Arbeit: {formData.hasMobilityCostDeduction === "yes" ? formData.mobilityCostAmount + " " + formData.mobilityCostUnit : "keine Abzüge"}
      </Grid>
      <Box id={"hasOtherExpensesDeduction"} />
      <Grid sx={summaryStyle.addMargin} size={12}>
        Werbungskosten: {formData.hasOtherExpensesDeduction === "yes" ? formData.otherExpensesAmount + " €" : "keine Abzüge"}
      </Grid>
      {formData.hasIncomeLiving === "no" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            Wohnkosten
          </Grid>
          <Grid size={12}>
            {formData.livingType === "rent" ? "Ich wohne zur Miete" : "Ich bin Eigentümer"}
            <br />
            Größe des Wohnraums: {formData.appartmentSize} m², {formData.numberRooms} Zimmer
            <br />
            {formData.numberRoommates === 0 && "Ich lebe alleine"}
            {formData.numberRoommates === 1 && "Ich lebe mit einer Person zusammen"}
            {formData.numberRoommates > 1 && "Ich lebe mit " + formData.numberRoommates + " Personen zusammen"}
            <br />
            {formData.livingType === "rent" ? "Kaltmiete: " : "Zinsen und Tilgung: "}
            {formData.basicRentOrRepayment} €<br />
            Heizungskosten: {formData.heatingCosts}
            <br />
            Nebenkosten: {formData.additionalCosts}
            <br />
            Ich zahle davon {formData.costPaidByPetitioner} €<br />
            <br />
          </Grid>

          {formData.livingType !== "rent" && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"hasPropertyLoans"} />
                Immobilienkredite
              </Grid>
              <Grid size={12}>
                {formData.hasPropertyLoans === "no" ? (
                  "Keine Immobilienkredite"
                ) : (
                  <>
                    {formData.propertyLoans?.map((propertyLoan: Record<string, any>, key: number) => (
                      <React.Fragment key={key}>
                        Kredit bei {propertyLoan.bank} seit {propertyLoan.date}
                        <br />
                        Darlehensnehmer: {propertyLoan.borrowers}
                        <br />
                        Restschuld von {propertyLoan.outstandingDebt}, zu zahlen mit {propertyLoan.repayment} €/Monat bis {propertyLoan.remainingTerm}
                        <br />
                        <br />
                      </React.Fragment>
                    ))}
                  </>
                )}
              </Grid>
            </>
          )}
        </>
      )}
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasOtherPaymentObligations"} />
        Sonstige Zahlungsverpflichtungen
      </Grid>
      <Grid size={12}>
        {formData.hasOtherPaymentObligations === "no" ? (
          "Keine sonstigen Zahlungsverpflichtungen"
        ) : (
          <>
            {formData.paymentObligations?.map((paymentObligation: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                {paymentObligation.name}
                <br />
                Restschuld von {paymentObligation.outstandingDebt} €, zu zahlen mit {paymentObligation.repayment} €/Monat (davon{" "}
                {paymentObligation.petitionerShare} € durch mich) bis {paymentObligation.remainingTerm}
                <br />
                <br />
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasSpecialFinancialBurdens"} />
        Besondere Belastungen
      </Grid>
      <Grid size={12}>
        {formData.hasSpecialFinancialBurdens === "no" ? (
          "Keine besonderen Belastungen"
        ) : (
          <>
            {formData.specialFinancialBurdens?.map((specialFinancialBurden: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                {specialFinancialBurden.description}
                <br />
                Ich zahle davon {specialFinancialBurden.petitionerShare} €
                <br />
                <br />
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
    </>
  );
};

export default CostsSummary;
